<template>
    <span
        v-if="score !== null && score !== undefined"
        class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium"
        :class="badge.class"
    >
        {{ badge.label }}
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    score: number | null;
}>();

const badge = computed(() => {
    if (props.score >= 0.7) {
        return { label: 'Člověk', class: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' };
    }
    if (props.score >= 0.3) {
        return { label: 'Pravděpodobně člověk', class: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200' };
    }
    return { label: 'Podezřelé', class: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200' };
});
</script>
